import * as React from 'react';

function IconZoomIn(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M15.386 14.113l-3.455-3.455a6.398 6.398 0 001.302-3.867A6.45 6.45 0 006.791.349 6.45 6.45 0 00.35 6.792a6.45 6.45 0 006.441 6.441 6.4 6.4 0 003.867-1.302l3.456 3.456a.897.897 0 001.272-.001.9.9 0 000-1.273zM2.15 6.792A4.647 4.647 0 016.79 2.15a4.646 4.646 0 014.641 4.64 4.646 4.646 0 01-4.64 4.642 4.645 4.645 0 01-4.642-4.64z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoIconZoomIn = React.memo(IconZoomIn);
export default MemoIconZoomIn;
